import React, {} from "react";
import {OrganizationTableWidget1} from "../widgets/advance-tables/OrganizationTableWidget1";

export function OrganizationList() {
    return <OrganizationTableWidget1/>
}

